import { MVP } from './mvp'

// Chemins du portail (S44, refondu S49 — ADR-068) — SOURCE UNIQUE des URLs.
// L'espace producteur vit sous le prefixe /producteur : les pages EXCLUSIVEMENT
// producteur y sont adressees (l'URL fait foi, plus de garde de casquette dans
// les composants) ; les onglets PARTAGES (/account, /wallet, /explore...)
// restent communs aux deux casquettes, leur contenu suit la casquette d'etat.
// Entrer sous /producteur BASCULE la casquette (absorbe le lien historique).

export const ROUTES = {
  accueil: '/',
  design: '/design',
  connexion: '/connexion',
  devenirProducteur: '/devenir-producteur',
  // Modules plein ecran (facette client)
  paniers: '/paniers',
  // Page publique d'un producteur (S62) — l'adresse que l'on PARTAGE. Prefixe
  // court `/p/` : hors de `/producteur` (espace prive) et lisible sur un QR code.
  producteurPublic: {
    motif: '/p/:id',
    vers: (id) => `/p/${id}`,
  },
  marche: {
    motif: '/marche/:id',        // pour <Route path>
    prefixe: '/marche/',
    vers: (id) => `/marche/${id}`,
  },
  // Sous-vues du Compte (S55) : la hierarchie du chemin EST la hierarchie
  // des retours — le back navigateur traverse le Compte comme le reste.
  compte: {
    base: '/account',
    profil: '/account/profil',
    securite: '/account/securite',
    dossier: '/account/dossier', // Dossier exposant (S73, v7.5)
    pin: '/account/securite/pin',
    aide: '/account/aide',
    aideFaq: '/account/aide/faq',
    aideContact: '/account/aide/contact',
  },
  // Espace producteur (prefixe — <Route nest> dans App.jsx)
  producteur: {
    base: '/producteur',
    accueil: '/producteur',
    explore: '/producteur/explore',
    activite: '/producteur/activite',
    offres: '/producteur/offres',
    marches: '/producteur/marches',       // onglet Évènements du hub producteur (S62)
    stand: '/producteur/stand',           // sous-page « Mon stand » (S62)
    profil: '/producteur/profil',
    organisation: '/producteur/organisation',
    facturation: '/producteur/facturation',
    paiement: '/producteur/paiement',
    // Modules plein ecran producteur (hors coquille du hub)
    marche: '/producteur/marche',
    paniers: '/producteur/paniers',
  },
}

// Chemin de chaque onglet du hub, PAR casquette. Les cles d'onglets (hubTab)
// restent le vocabulaire interne (barre basse, backChip, ONGLET_PARENT) ; seule
// l'adresse change selon la casquette pour 'home' et les onglets producteur.
export const CHEMINS_ONGLETS = {
  client: {
    home: ROUTES.accueil,
    explore: '/explore',
    favorites: '/favorites',
    account: '/account',
    wallet: '/wallet',
    parametres: '/parametres',
    notifications: '/notifications',
  },
  producer: {
    home: ROUTES.producteur.accueil,
    explore: ROUTES.producteur.explore,
    account: '/account',
    wallet: '/wallet',
    parametres: '/parametres',
    notifications: '/notifications',
    activite: ROUTES.producteur.activite,
    offers: ROUTES.producteur.offres,
    marches: ROUTES.producteur.marches,
    stand: ROUTES.producteur.stand,
    profilprod: ROUTES.producteur.profil,
    organisation: ROUTES.producteur.organisation,
    facturation: ROUTES.producteur.facturation,
    paiement: ROUTES.producteur.paiement,
  },
}

// Index inverse : chemin -> cle d'onglet (les chemins communs pointent la meme cle).
export const TAB_PAR_CHEMIN = {}
for (const mode of ['client', 'producer']) {
  for (const [tab, chemin] of Object.entries(CHEMINS_ONGLETS[mode])) {
    TAB_PAR_CHEMIN[chemin] = tab
  }
}
// Les sous-vues du Compte allument l'onglet Compte (barre basse).
for (const chemin of Object.values(ROUTES.compte)) {
  if (chemin.startsWith('/') && !chemin.includes('*')) TAB_PAR_CHEMIN[chemin] = 'account'
}

/** Chemin d'un onglet pour la casquette donnee (repli : l'autre casquette). */
export const cheminOnglet = (tab, hubMode = 'client') =>
  CHEMINS_ONGLETS[hubMode]?.[tab]
  ?? CHEMINS_ONGLETS.client[tab]
  ?? CHEMINS_ONGLETS.producer[tab]

// Onglet PARENT d'un sous-onglet — sert la SURBRILLANCE de la barre basse
// (le retour du header, lui, est declare par chaque page/route — cf. PageHub).
export const ONGLET_PARENT = {
  wallet: 'account',
  facturation: 'account',
  ...(MVP.COMPTE_DANS_BARRE_PRODUCTEUR ? { profilprod: 'account' } : {}), // S62 : onglet a part entiere sinon
  organisation: 'account',
  paiement: 'account',
  parametres: 'account',
  notifications: 'account',
  ...(MVP.EXPLORER_PRODUCTEUR ? { marches: 'explore' } : {}), // S62 : onglet a part entiere sinon
  stand: 'marches',     // sous-page « Mon stand » allume Évènements
  activite: 'account',  // « Mon activite » s'ouvre depuis le Compte (rouverte S71)
}
